export enum NotificationType {
  CONTACT_REQUEST_CREATED = 'CONTACT_REQUEST_CREATED',
  CONTACT_REQUEST_ANSWERED = 'CONTACT_REQUEST_ANSWERED',
  CALENDAR_EVENT_UPCOMING = 'CALENDAR_EVENT_UPCOMING',
  KEEP_CONTACT_REMINDER = 'KEEP_CONTACT_REMINDER',
  SCHEDULED_MESSAGE_UPCOMING = 'SCHEDULED_MESSAGE_UPCOMING',
  /** « Votre message programmé est parti chez X » */
  SCHEDULED_MESSAGE_SENT = 'SCHEDULED_MESSAGE_SENT',
  BIRTHDAY_UPCOMING = 'BIRTHDAY_UPCOMING',
  EVENT_REMINDER = 'EVENT_REMINDER',
  EVENT_ORGANIZER_MESSAGE = 'EVENT_ORGANIZER_MESSAGE',
}

export enum ContactRequestAnswer {
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
}

export interface ContactRequestCreatedNotificationData {
  contactRequestId: string
  senderId: string
}

export interface ContactRequestAnsweredNotificationData {
  contactRequestId: string
  recipientId: string
  answer: ContactRequestAnswer
  /** Where the new contact is filed: PRIVATE or PROFESSIONAL. */
  scope?: string
}

export interface CalendarEventUpcomingNotificationData {
  calendarEventId: string
  participantAccountIds?: string[]
  startDateTime: string
}

export interface KeepContactReminderNotificationData {
  keepContactId: string
  contactId: string
  keepDate: string
  /** Ready-made text of the post-event follow-up ("Relancer Julien ?" / "Vous vous êtes rencontrés à …"). */
  pushCopy?: { title: string; body: string }
}

export interface ScheduledMessageUpcomingNotificationData {
  scheduledMessageId: string
  contactId: string
  scheduledAt: string
}

export interface ScheduledMessageSentNotificationData {
  scheduledMessageId: string
  /** The person it was sent to (null for a group). */
  contactId: string | null
  groupId: string | null
  groupTitle: string | null
  conversationId: string
  /** The beginning of the message. */
  preview: string
  sentAt: string
}

export interface BirthdayUpcomingNotificationData {
  contactId: string
  birthDate: string
  /** The card of the day before: « Demain, X fête ses 36 ans ». */
  eve?: boolean
}

export interface EventReminderNotificationData {
  eventId: string
  eventCode: string
  kind: 'day_before' | 'day_of'
  pushCopy: { title: string; body: string }
}

export interface EventOrganizerMessageNotificationData {
  eventId: string
  eventCode: string
  subject: string
  pushCopy: { title: string; body: string }
}

export type NotificationData =
  | ContactRequestCreatedNotificationData
  | ContactRequestAnsweredNotificationData
  | CalendarEventUpcomingNotificationData
  | KeepContactReminderNotificationData
  | ScheduledMessageUpcomingNotificationData
  | ScheduledMessageSentNotificationData
  | BirthdayUpcomingNotificationData
  | EventReminderNotificationData
  | EventOrganizerMessageNotificationData

export interface Notification {
  id: string
  type: NotificationType
  data: NotificationData
  recipientId: string
  pushedAt: string | null
  readAt: string | null
  /** When it is due: the day of a follow-up, the start of a rendez-vous… */
  eventAt?: string | null
  createdAt: string
  updatedAt: string
  /** On a contact request: the contacts you share with that person. */
  mutualContacts?: MutualContacts
}

export interface MutualContacts {
  count: number
  people: { id: string; fullName: string; avatarUrl: string | null }[]
}

